import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "highlight",
})
export class HighlightPipe implements PipeTransform {
  transform(value: any, search: string): string {
    if (!value) return "";

    const text = value.toString();

    if (!search) return text;

    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, '<span class="highlight match-item">$1</span>');
  }
}
